/** @format */

import { Avatar, Box, ListItemAvatar, ListItemText, Stack, SvgIcon, Typography } from '@mui/material';
import Mail04Icon from '@untitled-ui/icons-react/build/esm/Mail04';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { removePushAssignedToBookingRequest } from 'src/layouts/dashboard/booking-notice-button/booking-notice.slice';
import BookingWrapMessage from './booking-wrap-message';
import { refreshKeyConfig } from 'src/config';
import { getTime } from 'date-fns';
import { setRefesh } from 'src/store/app-slice';
import { get } from 'lodash';
import LicensePlate from '../license-plate';
import CircleColor from '../circle-color';
import LicensePlateColor from '../license-plate-color';

const BookingRequestAssignedNotice = ({ toastId, content }) => {
  const dispatch = useDispatch();

  const requestId = content.id;
  useEffect(() => {
    if (toastId) {
      // [nhieuxe] Đã chỉ định cho nhà xe, xóa khỏi notice bar
      dispatch(removePushAssignedToBookingRequest(requestId));
      // [nhaxe] Refresh lại overview
      dispatch(
        setRefesh({
          [refreshKeyConfig.nxOverview]: getTime(new Date()),
          [refreshKeyConfig.carList]: getTime(new Date())
        })
      );
    }
  }, [toastId, requestId]);
  const requestCar = get(content, 'requestCar');
  return (
    <>
      <ListItemAvatar sx={{ mt: 0.5 }}>
        <Avatar>
          <SvgIcon sx={{ color: 'secondary.main' }}>
            <Mail04Icon />
          </SvgIcon>
        </Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexWrap: 'wrap',
              m: 0
            }}
          >
            <Stack direction="row" columnGap={0.5} width="100%">
              <Typography sx={{ mr: 0.5 }} variant="subtitle1">
                {content.tagKey}
              </Typography>
              <Typography variant="subtitle1" color="secondary.main">
                đã chấp nhận giao.
              </Typography>
            </Stack>
            {requestCar && (
              <BookingWrapMessage borderColor="warning.main">
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Xe :</Typography>
                  <Typography variant="subtitle2" color="primary.main">
                    {requestCar?.model?.name} {` (${requestCar.inServiceYear})`}
                  </Typography>
                </Stack>
                <Stack direction="row" columnGap={0.5} width="100%" alignItems="baseline">
                  <Typography variant="body2">Biển số :</Typography>
                  <LicensePlateColor licensePlate={requestCar.licensePlate} color={requestCar.color} />

                  {/* <Typography variant="subtitle2" color="primary.main">
                    {requestCar.licensePlate}
                  </Typography> */}
                </Stack>
              </BookingWrapMessage>
            )}
            <BookingWrapMessage>
              <Typography variant="body2">{content.bookingDescription}</Typography>
            </BookingWrapMessage>
          </Box>
        }
        primaryTypographyProps={{ component: 'div' }} // Chuyển thẻ <p> thành <div>
        secondaryTypographyProps={{ component: 'div' }}
        sx={{ my: 0 }}
      />
    </>
  );
};

export default BookingRequestAssignedNotice;
